/* ==========================================================================
   Bundle PDP value stack — the "ends in" countdown.

   Counts down to one fixed timestamp rendered by Liquid from the section
   setting. It never rolls over or restarts per visitor: when the deadline
   passes it either hides itself or shows the ended message, so the urgency
   on the page stays truthful.
   ========================================================================== */
(function () {
  'use strict';

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function format(seconds) {
    var d = Math.floor(seconds / 86400);
    var h = Math.floor((seconds % 86400) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = seconds % 60;
    return (d > 0 ? d + 'd ' + pad(h) : String(h)) + ':' + pad(m) + ':' + pad(s);
  }

  function start(node) {
    var endsAt = Number(node.dataset.endsAt);
    if (!endsAt) return;

    var template = node.dataset.template || '[time]';
    var endedText = node.dataset.ended || '';
    var timer = null;

    function tick() {
      var remaining = Math.floor(endsAt - Date.now() / 1000);

      if (remaining <= 0) {
        window.clearInterval(timer);
        if (endedText) {
          node.textContent = endedText;
        } else {
          node.hidden = true;
        }
        return;
      }

      node.textContent = template.replace('[time]', format(remaining));
    }

    tick();
    timer = window.setInterval(tick, 1000);
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-vs-countdown]').forEach(function (node) {
      if (node.dataset.vsReady === 'true') return;
      node.dataset.vsReady = 'true';
      start(node);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
